"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var extended_1 = require("../util/extended");
var interval_1 = require("../util/interval");
/**
 * 计算线性的 ticks，使用 wilkinson extended 方法
 * @param cfg 度量的配置项
 * @returns 计算后的 ticks
 */
function linear(cfg) {
    var min = cfg.min, max = cfg.max, tickCount = cfg.tickCount, nice = cfg.nice, tickInterval = cfg.tickInterval;
    if (tickInterval) {
        return interval_1.default(min, max, tickInterval).ticks;
    }
    return extended_1.default(min, max, tickCount, nice).ticks;
}
exports.default = linear;
//# sourceMappingURL=linear.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/scale/lib/tick-method/linear.js
// module id = 1075
// module chunks = 37